import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useWindowSize from '../hooks/useWindowResize';
import { useIntl } from 'react-intl';

const Services = () => {
	const theme = useTheme();
	const { width } = useWindowSize();
	const {
		messages: { services },
	} = useIntl();

	return (
		<Grid
			display={'grid'}
			position={'relative'}
			rowGap={{ xs: '50px', md: '100px' }}
			py={{ xs: '50px', md: '100px' }}
			px={'9.5%'}
		>
			<Grid
				display={'grid'}
				gap={'25px'}
				gridTemplateColumns={{
					xs: '1fr',
					md: '2fr 3fr',
				}}
				gridTemplateRows={'max-content max-content'}
			>
				<Grid
					gridRow={width < theme.breakpoints.values.md ? '2/3' : ''}
					height={'max-content'}
				>
					<img
						width={'100%'}
						height={'100%'}
						src={'/assets/Images/TrainStation.png'}
						alt={'train'}
						style={{ objectFit: 'contain', aspectRatio: '1/1' }}
					/>
				</Grid>
				<Grid
					display={'grid'}
					gap={'25px'}
					height={'max-content'}
				>
					{services?.map((service, index) => (
						<Paragraph
							key={index}
							title={service.title}
							para={service.para}
						/>
					))}
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Services;

// import { useState } from 'react';
//
// import { useIntl } from 'react-intl';
//

// const Services = () => {
// 	const { $t } = useIntl();
// 	const theme = useTheme();
// 	const [activeTab, setActiveTab] = useState(1);
// 	const navBarList = [
// 		{
// 			id: 1,
// 			title: $t({ id: 'RailroadTransportationCardTitle' }),
// 			component: <ServicesAltynRail />,
// 		},
// 		{
// 			id: 5,
// 			title: $t({ id: 'ImportsAndExportsTitleServices' }),
// 			component: <ServicesAltynImportExport />,
// 		},
// 		{
// 			id: 3,
// 			title: $t({ id: 'ClearanceTitleServices' }),
// 			component: <ServicesAltynFree />,
// 		},
// 	];

// 	return (
// 		<Grid
// 			display={'grid'}
// 			position={'relative'}
// 			rowGap={{ xs: '50px', md: '100px' }}
// 			py={{ xs: '50px', md: '100px' }}
// 			px={'9.5%'}
// 		>
// 			<Grid
// 				display={'grid'}
// 				container
// 				height={'40px'}
// 				width={'100%'}
// 				gridTemplateColumns={`repeat(${navBarList.length}, 1fr)`}
// 				style={{
// 					cursor: 'pointer',
// 				}}
// 				bgcolor={theme.palette.secondary.one}
// 				borderRadius={'30px'}
// 				overflow={'hidden'}
// 			>
// 				{navBarList?.map(({ title, id }) => (
// 					<Grid
// 						key={id}
// 						textAlign={'center'}
// 						fontWeight={activeTab === id ? 900 : 500}
// 						fontSize={'16px'}
// 						lineHeight={'40px'}
// 						color={activeTab === id ? theme.palette.info.one : 'white'}
// 						bgcolor={activeTab === id ? theme.palette.primary.one : 'transparent'}
// 						onClick={() => setActiveTab(id)}
// 					>
// 						{title}
// 					</Grid>
// 				))}
// 			</Grid>
// 			<Grid
// 				position={'absolute'}
// 				bottom={0}
// 				right={0}
// 				zIndex={1}
// 			>
// 				<img
// 					width={'100%'}
// 					src={'/assets/Images/back.svg'}
// 					alt={'background'}
// 				/>
// 			</Grid>
// 			<Grid zIndex={2}>{navBarList.find(item => item.id === activeTab)?.component}</Grid>
// 		</Grid>
// 	);
// };

// const ServicesAltynRail = () => {
// 	const {
// 		messages: { servicesAltynRail },
// 	} = useIntl();
// 	const theme = useTheme();
// 	const { width } = useWindowSize();

// 	return (
// 		<Grid
// 			display={'grid'}
// 			gap={'25px'}
// 			gridTemplateColumns={{
// 				xs: '1fr',
// 				md: '2fr 3fr',
// 			}}
// 			gridTemplateRows={'max-content max-content'}
// 		>
// 			<Grid
// 				gridRow={width < theme.breakpoints.values.md ? '2/3' : ''}
// 				height={'max-content'}
// 			>
// 				<img
// 					width={'100%'}
// 					height={'100%'}
// 					src={'/assets/Images/TrainStation.png'}
// 					alt={'train'}
// 					style={{ objectFit: 'contain', aspectRatio: '1/1' }}
// 				/>
// 			</Grid>
// 			<Grid
// 				display={'grid'}
// 				gap={'25px'}
// 			>
// 				{servicesAltynRail?.map((service, index) => {
// 					if (service.type === 'paragraph')
// 						return (
// 							<Paragraph
// 								key={index}
// 								title={service.title}
// 								para={service.para}
// 							/>
// 						);
// 					else if (service.type === 'image')
// 						return (
// 							<Image
// 								key={index}
// 								src={service.src}
// 								text={service.text}
// 							/>
// 						);
// 					else return null;
// 				})}
// 			</Grid>
// 		</Grid>
// 	);
// };

// const ServicesAltynImportExport = () => {
// 	const {
// 		messages: { servicesAltynImportExport },
// 	} = useIntl();
// 	const theme = useTheme();
// 	const { width } = useWindowSize();

// 	return (
// 		<Grid
// 			display={'grid'}
// 			gap={'25px'}
// 			gridTemplateColumns={{
// 				xs: '1fr',
// 				md: '2fr 3fr',
// 			}}
// 			gridTemplateRows={'max-content max-content'}
// 		>
// 			<Grid
// 				gridRow={width < theme.breakpoints.values.md ? '2/3' : ''}
// 				height={'max-content'}
// 			>
// 				<img
// 					width={'100%'}
// 					height={'100%'}
// 					src={'/assets/Images/TrainStation.png'}
// 					alt={'train'}
// 					style={{ objectFit: 'contain', aspectRatio: '1/1' }}
// 				/>
// 			</Grid>
// 			<Grid
// 				display={'grid'}
// 				gap={'25px'}
// 			>
// 				{servicesAltynImportExport?.map((service, index) => {
// 					if (service.type === 'paragraph')
// 						return (
// 							<Paragraph
// 								key={index}
// 								title={service.title}
// 								para={service.para}
// 							/>
// 						);
// 					else if (service.type === 'image')
// 						return (
// 							<Image
// 								key={index}
// 								src={service.src}
// 								text={service.text}
// 							/>
// 						);
// 					else if (service.type === 'list')
// 						return (
// 							<List
// 								key={index}
// 								title={service.title}
// 								para={service.para}
// 								list={service.list}
// 							/>
// 						);
// 					else return null;
// 				})}
// 			</Grid>
// 		</Grid>
// 	);
// };

// const ServicesAltynFree = () => {
// 	const {
// 		messages: { servicesAltynFree },
// 	} = useIntl();
// 	const theme = useTheme();
// 	const { width } = useWindowSize();

// 	return (
// 		<Grid
// 			display={'grid'}
// 			gap={'25px'}
// 			gridTemplateColumns={{
// 				xs: '1fr',
// 				md: '2fr 3fr',
// 			}}
// 			gridTemplateRows={'max-content max-content'}
// 		>
// 			<Grid
// 				gridRow={width < theme.breakpoints.values.md ? '2/3' : ''}
// 				height={'max-content'}
// 			>
// 				<img
// 					width={'100%'}
// 					height={'100%'}
// 					src={'/assets/Images/TrainStation.png'}
// 					alt={'train'}
// 					style={{ objectFit: 'contain', aspectRatio: '1/1' }}
// 				/>
// 			</Grid>
// 			<Grid
// 				display={'grid'}
// 				gap={'25px'}
// 			>
// 				{servicesAltynFree?.map((service, index) => {
// 					if (service.type === 'paragraph')
// 						return (
// 							<Paragraph
// 								key={index}
// 								title={service.title}
// 								para={service.para}
// 							/>
// 						);
// 					else if (service.type === 'image')
// 						return (
// 							<Image
// 								key={index}
// 								src={service.src}
// 								text={service.text}
// 							/>
// 						);
// 					else if (service.type === 'list')
// 						return (
// 							<List
// 								key={index}
// 								title={service.title}
// 								para={service.para}
// 								list={service.list}
// 							/>
// 						);
// 					else return null;
// 				})}
// 			</Grid>
// 		</Grid>
// 	);
// };

const Paragraph = ({ title, para = [] }) => {
	return (
		<Grid
			display={'grid'}
			gap={'16px'}
			height={'max-content'}
		>
			<Typography
				fontWeight={900}
				variant={'h3'}
				fontSize={'20px'}
			>
				{title}
			</Typography>
			<Grid
				display={'grid'}
				gap={'10px'}
			>
				{para?.map((p, index) => (
					<Typography
						key={index}
						textAlign={'justify'}
						fontSize={'16px'}
					>
						{p}
					</Typography>
				))}
			</Grid>
		</Grid>
	);
};

// const Image = ({ src, text }) => {
// 	return (
// 		<Grid
// 			display={'grid'}
// 			gap={'5px'}
// 			justifyItems={'center'}
// 		>
// 			<Grid width={'90%'}>
// 				<img
// 					src={src}
// 					width={'100%'}
// 					height={'100%'}
// 					alt={text}
// 				/>
// 			</Grid>
// 			<center>{text}</center>
// 		</Grid>
// 	);
// };

// const List = ({ title, para = [], list = [] }) => {
// 	return (
// 		<Grid
// 			display={'grid'}
// 			gap={'16px'}
// 		>
// 			<Typography
// 				fontWeight={900}
// 				variant={'h3'}
// 				fontSize={'20px'}
// 			>
// 				{title}
// 			</Typography>
// 			<Grid
// 				display={'grid'}
// 				gap={'10px'}
// 			>
// 				{para?.map((p, index) => (
// 					<Typography
// 						key={index}
// 						textAlign={'justify'}
// 						fontSize={'16px'}
// 					>
// 						{p}
// 					</Typography>
// 				))}
// 			</Grid>
// 			<ul>
// 				{list?.map((item, index) => (
// 					<li
// 						key={index}
// 						style={{ fontSize: '14px' }}
// 					>
// 						{item}
// 					</li>
// 				))}
// 			</ul>
// 		</Grid>
// 	);
// };

// export default Services;
